import { BrandDto } from '../../../features/firmware-management/dtos/brand.dto';
import { ModelDto } from '../../../features/firmware-management/dtos/model.dto';
import { ModelEntity } from '../../../features/firmware-management/models/model-entity.model';
import { ItemLabelModel } from '../../../features/shared/components/dropdown/models/dropdown-props.model';
import { ActiveInactiveStatusEnum } from '../../enums/active-inactive-status.enum';
import { FirmwareOverviewModel } from '../../models/firmware-overview.model';

export function mapActiveInactiveStatusEnumToItemLabelModel(
  status: ActiveInactiveStatusEnum
): ItemLabelModel {
  return {
    id: status,
    label: ActiveInactiveStatusEnum[status],
  };
}

export function mapFirmwaresModelToItemLabelModel(
  firmware: FirmwareOverviewModel
): ItemLabelModel {
  return {
    id: firmware.id,
    label: firmware.name,
  };
}

export function mapBrandDtoToBrandModel({ id, name }: BrandDto): ModelEntity {
  return {
    id,
    name,
  };
}

export function mapModelDtoToModelEntity(model: ModelDto): ModelEntity {
  return {
    id: model.id,
    name: model.name,
  };
}
